module.exports = __webpack_public_path__ + "img/logo-centerpag-white.1b082d93.svg";